export default "__VITE_ASSET__c16f9705__"